import { render, staticRenderFns } from "./DataTable.vue?vue&type=template&id=2d36afb4"
import script from "./DataTable.vue?vue&type=script&setup=true&lang=js"
export * from "./DataTable.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports